module.exports = __webpack_public_path__ + "static/media/1_4kee.b5654e56.png";